import { compact } from 'lodash';
import { Text } from '@cad-arc';

export function TileTooltip({
    callSign,
    beat,
    location,
    statusCode,
    skillsAndEquipment,
    unitTypes,
    cfs,
    callSigns,
    narrative,
}: {
    callSign?: string;
    beat?: string;
    location?: string;
    statusCode?: string;
    skillsAndEquipment?: string;
    unitTypes?: string;
    cfs?: string;
    callSigns?: string[];
    narrative?: string;
}): React.ReactElement {
    const tooltipLine1 =
        callSign || beat || statusCode
            ? `${callSign ? `${callSign}` : ''}${beat ? ` (${beat})` : ''}${
                  statusCode ? `: ${statusCode}` : ''
              }`
            : undefined;
    const tooltipLine2 = location ? `Location: ${location}` : undefined;
    const tooltipLine3 = cfs ? `CFS: ${cfs}` : undefined;
    const tooltipLine4 = skillsAndEquipment ? `Capabilities: ${skillsAndEquipment}` : undefined;
    const tooltipLine5 = unitTypes ? `Unit Types: ${unitTypes}` : undefined;
    const tooltipLine6 = callSigns ? `Assigned Units: ${callSigns.join(', ')}` : undefined;
    const tooltipLine7 = narrative ? `Narrative: ${narrative}` : undefined;

    const tooltipLines = compact([
        tooltipLine1,
        tooltipLine2,
        tooltipLine3,
        tooltipLine4,
        tooltipLine5,
        tooltipLine6,
        tooltipLine7,
    ]);

    return (
        <>
            {tooltipLines.map((line) => (
                <Text key={line}>{line}</Text>
            ))}
        </>
    );
}
